/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {ResourceHelper} from '../../components/util/resource-helper';
import {filterUrlLessTargeting} from '../../components/util/targeting-request';
import {updateEndDateForManualInput} from '../order/order-api-transforms';

export function transformLineItemResponse(lineItem: any): any {
  if (!lineItem) {
    return lineItem;
  }
  const transformed = {...lineItem};
  if (transformed.startDate) {
    transformed.startDate = new Date(transformed.startDate);
  }
  if (transformed.endDate) {
    transformed.endDate = new Date(transformed.endDate);
  }
  if (_.isPlainObject(transformed.bidSpecification)) {
    transformed.bidSpecification = _.cloneDeep(transformed.bidSpecification);
    transformed.bidSpecification.cpm = transformed.bidSpecification.cpm || {};
    transformed.bidSpecification.cpc = transformed.bidSpecification.cpc || {};
    transformed.bidSpecification.cpa = transformed.bidSpecification.cpa || {};
  }
  return transformed;
}

export function transformLineItemRequest(lineItem: any): any {
  const payload = _.cloneDeep(lineItem);
  filterUrlLessTargeting(payload);
  if (_.isPlainObject(payload.bidSpecification)) {
    _.forEach(['cpm', 'cpc'], (key) => ResourceHelper.checkMoney(payload, ['bidSpecification', key]));
    ResourceHelper.checkMoney(payload, ['bidSpecification', 'cpa'], 'cost');
    ResourceHelper.checkMoney(payload, ['bidSpecification', 'cpa'], 'initialECpm');
  }
  ResourceHelper.checkObjectives(payload);
  updateEndDateForManualInput(payload, 'endDate');
  delete payload.reportExecutions;
  return payload;
}
